import React from 'react'

import moment from 'moment'

import { CompanyData, EndUser } from '@driftt/api-types'
import { Flex } from '@driftt/dds'

import AccountInfoItem from 'pages/CCRMAccountDetailsPage/AccountDetailsHeader/AccountInfoItem'
import NavigationTabs from 'pages/CCRMAccountDetailsPage/AccountDetailsHeader/NavigationTabs'

import ContactInfoRow from './ContactInfoRow'

export interface UnifiedAttributes {
  firstName: {
    orgId: number
    value: string
    sourceEndUserId: number
  }
  lastName: {
    orgId: number
    value: string
    sourceEndUserId: number
  }
  lastActive: {
    orgId: number
    value: number
    sourceEndUserId: number
  }
  leadStage: {
    orgId: number
    value: string
    sourceEndUserId: number
  }
}

export type PersonalIntel = {
  firstName: string
  lastName: string
  displayName: string
  timeZone: string
  city: string
  country: string
  state: string
  zipCode: string
  latitude: number
  longitude: number
  displayLocation: string
  employmentName: string
  employmentTitle: string
  employmentRole: string
  employmentSeniority: string
  linkedinHandle: string
  twitterHandle: string
}

interface ContactInfoItemProps {
  contact: EndUser
  contactProperties: any
  unifiedAttributes: UnifiedAttributes
  personalIntel: PersonalIntel | null
  companyIntel: CompanyData | null
  accountId: string
  salesforceData: any
  tabNames: string[]
  activeTab: string
  onTabSelected: (selectedTab: string) => void
}

const ContactDetailsHeader = ({
  contact,
  contactProperties,
  unifiedAttributes,
  personalIntel,
  companyIntel,
  accountId,
  salesforceData,
  activeTab,
  tabNames,
  onTabSelected
}: ContactInfoItemProps) => {
  const userLocation = personalIntel?.displayLocation || contact?.attributes?.location

  return (
    <Flex
      direction="column"
      fullWidth
      gap={0}
      css={{
        backgroundColor: '$white',
        padding: '$5 $5 $0 $5',
        position: 'sticky',
        top: 0,
        borderBottom: '1px solid $gray3',
        zIndex: 900
      }}>
      <ContactInfoRow
        contact={contact}
        contactProperties={contactProperties}
        personalIntel={personalIntel}
        companyIntel={companyIntel}
        salesforceData={salesforceData}
        accountId={accountId}
      />
      <Flex
        css={{ padding: '$2 0', borderBottom: '1px solid $gray3' }}
        alignItems="center"
        justifyContent="space-evenly"
        fullWidth
        gap={2}>
        <AccountInfoItem
          label="Email"
          validation={!!contact?.email}
          property={contact?.email ?? ''}
        />
        <AccountInfoItem
          label="Phone"
          validation={!!contact?.phone}
          property={contact?.phone ?? ''}
        />
        <AccountInfoItem label="Location" validation={!!userLocation} property={userLocation} />
        <AccountInfoItem
          label="Lead stage"
          validation={!!unifiedAttributes?.leadStage?.value}
          property={unifiedAttributes?.leadStage?.value ?? ''}
        />
        <AccountInfoItem
          label="Last active"
          validation={!!unifiedAttributes?.lastActive?.value}
          property={moment(unifiedAttributes?.lastActive?.value).format('MMM Do h:mm:ss a') ?? ''}
        />
      </Flex>
      <NavigationTabs activeTab={activeTab} tabNames={tabNames} onTabSelected={onTabSelected} />
    </Flex>
  )
}

export default ContactDetailsHeader
